import { render, staticRenderFns } from "./VgtTableHeader.vue?vue&type=template&id=2d1be068&scoped=true"
import script from "./VgtTableHeader.vue?vue&type=script&lang=js"
export * from "./VgtTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1be068",
  null
  
)

export default component.exports